import { useState } from 'react'
import { ChevronDown, ChevronRight } from 'lucide-react'
import ReportRow from './ReportRow'
import ReportMonthPeriodSlotRow, { type MonthlyPeriodSlot } from './ReportMonthPeriodSlotRow'
import type WebInstrumentTaskReport from '@/shared/types/web/WebInstrumentTaskReport'

interface Props {
  label: string
  records: WebInstrumentTaskReport[]
  periodSlots?: MonthlyPeriodSlot[]
  defaultOpen?: boolean
}

const ReportMonthGroup = ({ label, records, periodSlots = [], defaultOpen = false }: Props) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div className="rounded-md border">
      <button
        type="button"
        className="flex w-full items-center justify-between px-4 py-3 text-left font-semibold hover:bg-muted/50 transition-colors"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
      >
        <span>{label}</span>
        <span className="text-muted-foreground">
          {isOpen ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
        </span>
      </button>

      {isOpen && (
        <div className="flex flex-col gap-2 px-4 pb-4">
          {records.map((record) => (
            <ReportRow key={record.id} record={record} />
          ))}
          {periodSlots.map((slot) => (
            <ReportMonthPeriodSlotRow
              key={`${slot.departmentId}-${slot.reportStartDate}`}
              slot={slot}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default ReportMonthGroup
